import FlumpSprite from "./FlumpSprite";
import FlumpClip from "./FlumpClip";
import FlumpMovieSymbol from "../symbols/FlumpMovieSymbol";
import FlumpLayerSymbol from "../symbols/FlumpLayerSymbol";
import FlumpLibrary from "../FlumpLibrary";

/**
 * TODO - Add description.
 */
export default class FlumpSubClip extends FlumpClip
{
    /**
    * @param {Phaser.Game} game - A reference to the currently running game.
    * @param {FlumpMovieSymbol[]} movieClips
    * @param {FlumpLibrary} flumpLibrary - FlumpLibrary.
    * @param {string} defaultClip
    * @param {FlumpLayerSymbol} layer - Layer json data.
    * @param {FlumpClip} movieClip - Parent movie clip.
    */
    constructor(game, movieClips, flumpLibrary, defaultClip, layer, movieClip)
    {
        super(game, movieClips, flumpLibrary, defaultClip);
        this.setupClip(layer, movieClip);
    }

    /**
    * Cleans up the FlumpSubClip.
    * @param {boolean} [destroyChildren=true] Defaulfs to true
    */
    destroy(destroyChildren = true)
    {
        this.movieClip = null;
        super.destroy(destroyChildren);
    }

    /**
    * Setup the layer for the current animation.
    * @param {FlumpLayerSymbol} layer - Layer json data.
    * @param {FlumpClip} movieClip - Parent movie clip.
    */
    setupClip(layer, movieClip)
    {
        /** @type {FlumpLayerSymbol} */
        this.layer = layer;
        /** @type {number} */
        this.keyframes = this.layer.keyframes;
        /** @type {number} */
        this.finalFrame = this.keyframes.length - 1;

        /** @type {FlumpClip} */
        this.movieClip = movieClip;
        /** @type {number} */
        this.frameRate = this.movieClip.frameRate;
        /** @type {number} */
        this.duration = this.movieClip.duration;
        /** @type {number} */
        this.playbackSpeed = 1;
        this._paused = false;
        /** @type {boolean} */
        this.visible = true;
        /** @type {boolean} */
        this.enabled = true;
        this.setActive(true);

        /** @ignore Current frame*/
        this.currentFrame = 0;
        /** @ignore Current keyframe index*/
        this.currentIndex = 0;
        /** @ignore Current keyframe*/
        this.currentKeyFrame = this.keyframes[this.currentIndex];
        /** @ignore Current keyframe duration*/
        this.currentDuration = 0;
        /** @ignore Current time in current keyframe*/
        this.currentTime = 0;

        this.nextKeyframe(true);
        this.updateChildTransform(this.currentKeyFrame.x, this.currentKeyFrame.y, this.currentKeyFrame.pivotX, this.currentKeyFrame.pivotY, this.currentKeyFrame.skewX, this.currentKeyFrame.skewY, this.currentKeyFrame.scaleX, this.currentKeyFrame.scaleY, this.currentKeyFrame.alpha);
    }

   /**
    * Go to new frame.
    * @param {number} newFrame - New frame to move to.
    * @param {number} playbackSpeed - Current playback speed.
    */
    goto(newFrame, playbackSpeed, looping)
    {
        this.playbackSpeed = playbackSpeed;

        if (this.currentFrame == newFrame)
        {
            return; // No change
        }

        if (newFrame < this.currentFrame) {
            this.currentIndex = 0;
            this.currentDuration = 0;
            this.currentFrame = 0;
            this.currentTime -= this.currentKeyFrame.duration;
            this.nextKeyframe();
        }

        this.composeFrame(newFrame, looping);
    }

    /** @internal */
    composeFrame(frame, looping)
    {
        this.currentFrame = frame;

        //TODO: Make this work
        if(frame >= this.layer.frames)
        {
            this.visible = false;
            this.currentIndex = this.finalFrame;
            this.keyframeUpdate = true;
            return;
        }

        while(true)
        {
            if(this.currentDuration <= this.currentFrame)
            {
                this.currentIndex++;
                this.nextKeyframe();
            }
            else
            {
                break;
            }
        }

        var kf = this.keyframes[this.currentIndex];
        var visible = kf.visible && kf.symbolName != null;
        this.visible = visible;
        if (!visible)
        {
            return;
        }

        var x = kf.x;
        var y = kf.y;
        var scaleX = kf.scaleX;
        var scaleY = kf.scaleY;
        var skewX = kf.skewX;
        var skewY = kf.skewY;
        var alpha = kf.alpha;

        if (kf.tweened && this.currentIndex < this.finalFrame && this.keyframes[this.currentIndex + 1].symbolName != null)
        {
            var interp = (this.currentFrame-kf.index) / kf.duration;
            var ease = kf.ease;
            if (ease != 0) {
                var t;
                if (ease < 0) {
                    // Ease in
                    var inv = 1 - interp;
                    t = 1 - inv*inv;
                    ease = -ease;
                } else {
                    // Ease out
                    t = interp*interp;
                }
                interp = ease*t + (1 - ease)*interp;
            }

            var nextKf = this.keyframes[this.currentIndex + 1];
            x += (nextKf.x-x) * interp;
            y += (nextKf.y-y) * interp;
            scaleX += (nextKf.scaleX-scaleX) * interp;
            scaleY += (nextKf.scaleY-scaleY) * interp;
            skewX += (nextKf.skewX-skewX) * interp;
            skewY += (nextKf.skewY-skewY) * interp;
            alpha += (nextKf.alpha-alpha) * interp;
        }

        this.updateChildTransform(x, y, this.currentKeyFrame.pivotX, this.currentKeyFrame.pivotY, skewX, skewY, scaleX, scaleY, alpha);
    }

    /** @internal */
    nextKeyframe(forceRestart = false)
    {
        if(this.currentIndex >= this.keyframes.length)
        {
            this.currentIndex = 0;
            this.currentDuration = 0;
            this.currentFrame = 0;
            this.currentTime -= this.currentKeyFrame.duration;
        }
        else
        {
            this.currentTime = 0;
        }

        this.currentKeyFrame = this.keyframes[this.currentIndex];
        this.currentDuration += this.currentKeyFrame.duration;

        if(this.currentKeyFrame.symbolName != null)
        {
            this.loop(this.currentKeyFrame.symbolName, forceRestart);
            this.visible = true;
        }
        else
        {
            this.visible = false;
        }
    }

    /** @internal */
    updateChildTransform(newX, newY, newPivotX, newPivotY, newSkewX, newSkewY, newScaleX, newScaleY, newAlpha)
    {
        this.position.set(newX, newY);
        this.pivot.set(newPivotX, newPivotY);
        this.skewX = newSkewX;
        this.skewY = newSkewY;
        this.scale.set(newScaleX, newScaleY);
        this.alpha = newAlpha;
    }

    /** @param {boolean} value - Enable/Disable layer. */
    setActive(value)
    {
        this.visible = value;
        this.enabled = value;
    }

    /** @type {boolean} */
    get paused()
    {
        return this._paused;
    }

    /** @type {bool} */
    set paused(val)
    {
        this._paused = val;
    }
}
